import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/cn';

function useQuestionTypes() {
  const { t } = useTranslation();
  return [
    { id: 'mcq', label: t('questions.mcq'), shortLabel: 'MCQ' },
    { id: 'short_answer', label: t('questions.shortAnswer'), shortLabel: 'Short' },
    { id: 'essay', label: t('questions.longResponse'), shortLabel: 'Long' },
    { id: 'fill_blank', label: t('questions.fillBlank'), shortLabel: 'Fill' },
    { id: 'table_completion', label: t('questions.tableSort'), shortLabel: 'Table' },
  ];
}

const QUESTION_TYPES = [
  { id: 'mcq', label: 'MCQ', shortLabel: 'MCQ' },
  { id: 'short_answer', label: 'Short Answer', shortLabel: 'Short' },
  { id: 'essay', label: 'Long Response', shortLabel: 'Long' },
  { id: 'fill_blank', label: 'Fill Blank', shortLabel: 'Fill' },
  { id: 'table_completion', label: 'Table Sort', shortLabel: 'Table' },
];

export default function QuestionTypeSelector({ value, onChange, className }) {
  const types = useQuestionTypes();
  return (
    <div className={cn('flex flex-wrap gap-1.5', className)}>
      {types.map((type) => {
        const isSelected = value === type.id;
        return (
          <button
            key={type.id}
            type="button"
            onClick={() => onChange(type.id)}
            className={cn(
              'px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200',
              isSelected
                ? 'bg-gray-900 text-white dark:bg-white dark:text-gray-900 shadow-[0_2px_8px_rgba(0,0,0,0.15)]'
                : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600'
            )}
          >
            {type.label}
          </button>
        );
      })}
    </div>
  );
}

export { QUESTION_TYPES };
